import { t } from '@/translations';
import { number, object, ref, string } from 'yup';

const registrationSchema = object({
    firstname: string().required(t('global.form_errors.required')),
    lastname: string().required(t('global.form_errors.required')),
    password: string().required(t('global.form_errors.required')),
    password_strength: number().min(1, t('invitation.form_register.validation.password_strength')),
    confirm_password: string()
        .required(t('global.form_errors.required'))
        .oneOf([ref('password')], t('invitation.form_register.validation.password_mismatch')),
});

export default registrationSchema;
